import { types } from '../actions/user';

const initialState = {
  pendingFlag: false,
  error: '',
  response: null,
  profile: null,
  temporaryJobSave: localStorage.getItem('tempoSavedJob') || '',
  updatingError: '',
  updatingPending: false
};

export default function reduce(state = initialState, action) {
  switch (action.type) {
    case types.SAVE_PERSONAL_DATA_PENDING:
      return { ...state, updatingPending: true, updatingError: '' };
    case types.SAVE_PERSONAL_DATA_REJECTED:
      return { ...state, updatingPending: false, updatingError: action.payload.message };
    case types.SAVE_PERSONAL_DATA_FULFILLED:
      return {
        ...state,
        pendingFlag: false,
        updatingPending: false,
        updatingError: '',
        error: '',
        response: action.payload?.Data,
        profile: { ...state.profile, ...action.payload }
      };
    case types.SAVE_USER_LOCATION_PENDING:
      return { ...state, updatingPending: true, updatingError: '' };
    case types.SAVE_USER_LOCATION_REJECTED:
      return { ...state, updatingPending: false, updatingError: action.payload.message };
    case types.SAVE_USER_LOCATION_FULFILLED:
      return {
        ...state,
        pendingFlag: false,
        updatingPending: false,
        updatingError: '',
        error: ''
      };
    case types.SAVE_CONTRACT_TYPE_PENDING:
      return { ...state, updatingPending: true, updatingError: '' };
    case types.SAVE_CONTRACT_TYPE_REJECTED:
      return { ...state, updatingPending: false, updatingError: action.payload.message };
    case types.SAVE_CONTRACT_TYPE_FULFILLED:
      return {
        ...state,
        pendingFlag: false,
        updatingPending: false,
        updatingError: '',
        error: ''
      };
    case types.SAVE_USER_DATA_FULFILLED:
      return { ...state, pendingFlag: false, error: '', response: action.payload?.Data };
    case types.SAVE_USER_DATA_PENDING:
      return { ...state, pendingFlag: true, error: '' };
    case types.SAVE_USER_DATA_REJECTED:
      return { ...state, pendingFlag: false, error: action.payload.message };
    case types.FETCH_USER_DATA_PENDING:
      return { ...state, pendingFlag: true, error: '', profile: null };
    case types.FETCH_USER_DATA_REJECTED:
      return { ...state, pendingFlag: false, error: action.payload.message, profile: null };
    case types.FETCH_USER_DATA_FULFILLED:
      return { ...state, pendingFlag: false, error: '', profile: action.payload.Data };
    case types.SET_USER_INDUSTRIES_PENDING:
      return { ...state, updatingPending: true, updatingError: '' };
    case types.SET_USER_INDUSTRIES_REJECTED:
      return { ...state, updatingPending: false, updatingError: action.payload.message };
    case types.SET_USER_INDUSTRIES_FULFILLED:
      return {
        ...state,
        pendingFlag: false,
        updatingPending: false,
        updatingError: '',
        error: '',
        profile: {
          ...state.profile,
          UserIndustries: action.payload
        }
      };
    case types.SET_USER_FUNCTIONS_PENDING:
      return { ...state, updatingPending: true, updatingError: '' };
    case types.SET_USER_FUNCTIONS_REJECTED:
      return { ...state, updatingPending: false, updatingError: action.payload.message };
    case types.SET_USER_FUNCTIONS_FULFILLED:
      return {
        ...state,
        pendingFlag: false,
        updatingPending: false,
        updatingError: '',
        error: '',
        profile: {
          ...state.profile,
          UserJobFunctions: action.payload
        }
      };
    case types.SAVE_USER_RATES_PENDING:
      return { ...state, updatingPending: true, updatingError: '' };
    case types.SAVE_USER_RATES_REJECTED:
      return { ...state, updatingPending: false, updatingError: action.payload.message };
    case types.SAVE_USER_RATES_FULFILLED:
      return {
        ...state,
        pendingFlag: false,
        updatingPending: false,
        updatingError: '',
        error: '',
        profile: {
          ...state.profile,
          UserRates: [{ ...state.profile.UserRates[0], ...action.payload }]
        }
      };
    case types.SWITCH_JOB_SEEKING_FULFILLED:
      return {
        ...state,
        pendingFlag: false,
        error: '',
        profile: {
          ...state.profile,
          IsJobSeeking: action.payload
        }
      };
    case types.UPDATE_USER_DATA:
      return { ...state, profile: action.payload };
    case types.TEMPO_SAVE_JOB:
      return { ...state, temporaryJobSave: action.payload };
    case types.SET_USER_CONSENT_FULFILLED:
      return { ...state, profile: { ...state.profile, IsManageConcent: action.payload } };
    case types.SAVE_WORK_HISTORY_PENDING:
      return { ...state, updatingPending: true, updatingError: '' };
    case types.SAVE_WORK_HISTORY_REJECTED:
      return { ...state, updatingPending: false, updatingError: action.payload.message };
    case types.SAVE_WORK_HISTORY_FULFILLED:
      return {
        ...state,
        updatingPending: false,
        updatingError: '',
        profile: {
          ...state.profile,
          WorkHistories: state.profile.WorkHistories.map((work) =>
            work.Id === action.payload.Data.Id ? action.payload.Data : { ...work, CurrentlyWorkThere: false }
          )
        }
      };
    case types.CREATE_NEW_WORK_HISTORY_PENDING:
      return { ...state, updatingPending: true, updatingError: '' };
    case types.CREATE_NEW_WORK_HISTORY_REJECTED:
      return { ...state, updatingPending: false, updatingError: action.payload.message };
    case types.CREATE_NEW_WORK_HISTORY_FULFILLED:
      return {
        ...state,
        updatingPending: false,
        updatingError: '',
        profile: { ...state.profile, WorkHistories: [...state.profile.WorkHistories, action.payload.Data] }
      };
    case types.SYNC_ADD_WORK:
      return {
        ...state,
        profile: { ...state.profile, WorkHistories: [...state.profile.WorkHistories, action.payload] }
      };
    case types.SYNC_UPDATE_WORK:
      return {
        ...state,
        profile: {
          ...state.profile,
          WorkHistories: state.profile.WorkHistories.map((work) =>
            work.Id === action.payload.Id ? action.payload : work
          )
        }
      };
    case types.SYNC_DELETE_WORK:
      return {
        ...state,
        profile: {
          ...state.profile,
          WorkHistories: state.profile.WorkHistories.filter((work) => work.Id !== action.payload)
        }
      };
    case types.VALIDATE_USER_FULFILLED:
      return {
        ...state,
        profile: {
          ...state.profile,
          validation: action.payload
        }
      };
    case types.GET_APPROVERS_LIST_FULFILLED:
      return {
        ...state,
        approvers: action.payload.map((approver) => ({
          key: approver.Id,
          label: `${approver.User.FirstName} ${approver.User.LastName}`,
          value: approver.Id
        }))
      };
    default:
      return state;
  }
}
